import { useNextRouter } from "@/data/Content/_NextRouter";
import { useLocalization } from "@/data/Localization";
import { ID } from "@/data/types/Basic";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import { HelloRetailProductGrid } from "./parts/ProductGrid";

export const HelloRetailCatalogEntryList:FC<{ id: ID }> = () => {

    const { searchResultsH1} = useLocalization('SearchResults');
    const router = useNextRouter();
    const {
        query: { searchTerm },
    } = router;
    return (
        <Stack spacing={2}>
            <Typography variant="h1" sx={{ mb: 2 }}>{searchTerm ? searchResultsH1.t({term: decodeURIComponent((searchTerm as string) || '')}) : ""}</Typography>
            <HelloRetailProductGrid />
        </Stack>
    );
}